/* eslint-disable react/destructuring-assignment */
import { Button, ContentCard, Label, ModalGeneric } from 'ypf-pas-general-ui-components';
import { BsEyeFill } from 'react-icons/bs';
import { useRef, useState, useContext } from 'react';
import PropTypes from 'prop-types';

import {
  putUbicationDetail,
  putUbicationDetailOyM
} from '../../../../adapters/requestServiceDetails/requestServiceDetailsAdapter';
import { TypeAndObjectImputationPermissions } from '../../../../components/MonthlyServiceRequest/RequestDetailTypes';
import LoaderContext from '../../../../context/LoaderProvider';
import useToast from '../../../../hooks/useToast';
import { statusEnum, ubicationTypeEnum, assignmentTypeEnum } from '../../../../utils/dataStatus';
import { DetailRequest } from '../../../../utils/globalPropTypes';
import useRequestDetailPermissions from '../../../../hooks/useRequestDetailPermissions';
import useDetailsEventsModal from '../../../../hooks/useDetailsEventsModal';
import { checkRol } from '../../../../security';
import { aprobador } from '../../../../security/constantsRols';
import { updateImputationObjectSDSApprover } from '../../../../services/workReport';

import ImputationObjectDetail from './ImputationObjectDetail/ImputationObjectDetail';

const UbicationCard = ({
  details,
  tpyeAndObjectImputationPermissions,
  idStatus,
  setPendingEvent,
  withOutEventAssigned
}) => {
  const {
    handleShowDetailsEventsModal,
    handleOperations,
    handleHasTechnicalLocations,
    handleTitleModal
  } = useDetailsEventsModal();
  const [disabledActions, setDisabledActions] = useState(false);
  const [showModalDetail, setShowModalDetail] = useState(false);
  const businessUnit = details?.unidadNegocio?.nombre;
  const ubicationType = details?.tipoUbicacion?.nombre;
  const ubication = details?.ubicacionStr;

  const disabledEditStateCancelOrFinish =
    idStatus === statusEnum.cancelada || idStatus === statusEnum.finalizada;

  const isAsds = details?.tipoAsignacion?.id === assignmentTypeEnum.Automatica;

  const isOyM =
    details?.tipoUbicacion?.id !== ubicationTypeEnum.locacion &&
    details?.tipoUbicacion?.id !== ubicationTypeEnum.pozo;

  const { setLoader } = useContext(LoaderContext);
  const { setNewToast } = useToast();

  const { permissions } = useRequestDetailPermissions({
    notifyTo: details?.tipoNotificacionEnum,
    isASDS: isAsds,
    isOyM
  });

  const canUpdateIO =
    (tpyeAndObjectImputationPermissions.editWells &&
      details?.tipoUbicacion?.id === ubicationTypeEnum.locacion) ||
    tpyeAndObjectImputationPermissions.editObjectImputation ||
    (tpyeAndObjectImputationPermissions.editObjectImputation &&
      details?.tipoUbicacion?.id === ubicationTypeEnum.locacion);

  const form = useRef(null);

  const updateWellsWithModifiedProps2 = (originalWells, copyWells) =>
    originalWells
      ?.filter((originalWell, index) => {
        if (!copyWells?.length) return false;
        const modifiedWell = copyWells[index];

        const isImputationObjectModified =
          originalWell?.imputationObject?.id !== modifiedWell?.imputationObject?.id;
        const isImputationTypeModified =
          originalWell?.imputationType?.id !== modifiedWell?.imputationType?.id;

        return isImputationObjectModified || isImputationTypeModified;
      })
      .map((originalWell, index) => {
        const modifiedWell = copyWells[index];
        const updatedWell = { ...originalWell };

        // Actualizar los valores relevantes que han cambiado
        if (originalWell?.socCode !== modifiedWell?.socCode?.nombre) {
          updatedWell.socCode = modifiedWell?.socCode?.nombre || originalWell.socCode;
        }
        if (originalWell?.logisticCenter !== modifiedWell?.logisticCenter?.nombre) {
          updatedWell.logisticCenter =
            modifiedWell?.logisticCenter?.nombre || originalWell.logisticCenter;
        }

        return updatedWell;
      });

  const createBodyPostArray = (wellsArray, pozoIdManagment) =>
    wellsArray.map((well) => ({
      ...(pozoIdManagment && {
        pozoId: well?.well?.id
      }),
      ubicacion: details?.ubicacionStr,
      sociedad: well?.socCode,
      centro: well?.logisticCenter?.length > 1 ? String(well?.logisticCenter) : null,
      tipoImputacionId: well?.imputationType?.value,
      objetoImputacion: {
        id: well.imputationObject?.id,
        nombre: well.imputationObject?.nombre.split(' | ')[0]
      }
    }));

  const updateData = async () => {
    setLoader(true);
    try {
      const originalWells = form?.current?.values?.imputationObject?.wells;
      const copyWells = form?.current?.values?.imputationObject?.copyWells;
      const updatedWellsArray = updateWellsWithModifiedProps2(originalWells, copyWells);
      const imputationObjectValues = form.current?.values?.imputationObject;
      let data;

      if (imputationObjectValues?.esSoloAprobador) {
        const isLocationOrWell =
          details?.tipoUbicacion?.id === ubicationTypeEnum.pozo ||
          details?.tipoUbicacion?.id === ubicationTypeEnum.locacion;

        const bodyPostWellsArray = createBodyPostArray(updatedWellsArray, isLocationOrWell);

        await updateImputationObjectSDSApprover(details?.id, {
          objetosImputacion: bodyPostWellsArray
        });

        setShowModalDetail(false);
        setNewToast({
          type: 'SUCCESS',
          message: 'Se ha actualizado correctamente'
        });
        setLoader(false);
      } else if (isOyM) {
        data = await putUbicationDetailOyM(originalWells, details?.id);
      } else {
        data = await putUbicationDetail(originalWells, details?.id);
      }

      if (data) {
        setShowModalDetail(false);
        setNewToast({
          type: 'SUCCESS',
          message: `${data?.mensaje}`
        });
        setLoader(false);
      }
    } catch (error) {
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
      setLoader(false);
    }
  };
  const handleSetTitleModal = () => {
    handleTitleModal({
      title: `${ubication}`
    });
  };

  return (
    <>
      <ContentCard mark="none" orientation="horizontal-vertical">
        <div className="d-flex">
          <div className="d-flex flex-row">
            <Label
              label="Unidad de Negocio"
              size="md"
              sizeValue="md"
              value={businessUnit}
              variant="light"
            />
            <Label
              label="Tipo de ubicación"
              size="md"
              sizeValue="md"
              value={ubicationType}
              variant="light"
            />
            <Label label="Ubicación" size="md" sizeValue="md" value={ubication} variant="light" />
          </div>
          <div className="d-flex content-eye-button">
            {handleHasTechnicalLocations({ headData: details }) && (
              <Button
                className="eye-button"
                colorIcon="primary"
                icon={BsEyeFill}
                onClick={() => {
                  handleShowDetailsEventsModal({ showModal: true });
                  handleSetTitleModal();
                  handleOperations({
                    ubicationsData: details,
                    isFromHeadRequest: true,
                    requestData: { nroSolicitud: details.numero }
                  });
                }}
                sizeIcon="20px"
                type="button"
                widthButton="40px"
              />
            )}
          </div>
          <div className="d-flex flex-column">
            {permissions?.typeAndObjectImputation?.visualize && (
              <Label
                disabled={details.sinEventoAsignado}
                label="Tipo y objeto de imputación"
                onClick={() => {
                  if (!withOutEventAssigned) setShowModalDetail(true);
                }}
                size="md"
                sizeValue="lg"
                value="VER DETALLES"
                variant="light"
              />
            )}
            {checkRol(aprobador) && details?.esEditable && (
              <Label
                label="Evento"
                onClick={() => setPendingEvent(true)}
                size="md"
                sizeValue="lg"
                value="VER DETALLES"
                variant="light"
              />
            )}
          </div>
        </div>
      </ContentCard>
      <ModalGeneric
        backdrop="static"
        infoModal
        onHide={async () => setShowModalDetail(false)}
        primaryAction={canUpdateIO ? updateData : null}
        primaryActionDisabled={disabledEditStateCancelOrFinish || disabledActions}
        primaryActionLabel="Aceptar"
        secondaryAction={() => setShowModalDetail(false)}
        secondaryActionLabel="Salir"
        show={showModalDetail}
        size="xl"
        title="Detalles del tipo y objeto de imputación"
      >
        <ImputationObjectDetail
          details={details}
          disabledEditStateCancelOrFinish={disabledEditStateCancelOrFinish}
          form={form}
          isOyM={isOyM}
          setDisabledActions={setDisabledActions}
          tpyeAndObjectImputationPermissions={tpyeAndObjectImputationPermissions}
        />
      </ModalGeneric>
    </>
  );
};

export default UbicationCard;

UbicationCard.propTypes = {
  details: DetailRequest.isRequired,
  withOutEventAssigned: PropTypes.bool.isRequired,
  tpyeAndObjectImputationPermissions: TypeAndObjectImputationPermissions.isRequired,
  idStatus: PropTypes.number.isRequired,
  setPendingEvent: PropTypes.func
};
UbicationCard.defaultProps = {
  setPendingEvent: () => {}
};
